export default __webpack_public_path__ + "static/media/PROVIMENTO-187-2018.d8268bbe.pdf";